import { render, staticRenderFns } from "./ProductTypeSelection.vue?vue&type=template&id=8cbd3aa8&"
import script from "./ProductTypeSelection.vue?vue&type=script&lang=js&"
export * from "./ProductTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports